import React from "react"
import "assets/scss/main.scss"
import "react-datepicker/dist/react-datepicker.css"

import { LoadingProvider } from "context/loading-context"
import { useStore, usePersistor } from "lib/redux"
import { Provider } from "react-redux"
import { PersistGate } from 'redux-persist/integration/react'
import { useApollo } from "lib/apollo"
import { ApolloProvider } from "@apollo/client"
import Cookies from "js-cookie"
import LoadingScreen from "@components/global/loading-screen/loading-screen"
import TagManager from "react-gtm-module" //! For datalayer
import AppHooksProvider from "@components/hooks/AppHooksProvider"

const checkToken = () => {
  let access = Cookies.get(`${process.env.ACCESS_TOKEn}`)
  let guest = Cookies.get(`${process.env.GUEST_TOKEN}`)
  if (access) {
    return access
  } else {
    if (guest) return guest
    else return process.env.INIT_TOKEN
  }
}

export default function MyApp({ Component, pageProps, token }) {
  const client = useApollo(pageProps.initialApolloState, checkToken())
  const store = useStore()
  const persistor = usePersistor()
  
  React.useEffect(() => {
    if (TagManager.initialize) {
      TagManager.initialize({
        gtmId: process.env.GTAG_ID,
      })
    }
  }, [])
  return (
    <LoadingProvider>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <ApolloProvider client={client}>
            <AppHooksProvider>
              <div className="app-wrapper">
                <LoadingScreen />
                <Component {...pageProps} />
              </div>
            </AppHooksProvider>
          </ApolloProvider>
        </PersistGate>
      </Provider>
    </LoadingProvider>
  )
}

// MyApp.getInitialProps = async (appContext) => {
//   let appProps = await App.getInitialProps(appContext)
//   let { token } = await TokenValidation(appContext?.ctx)
//   return { ...appProps, token }
// }
